import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import _ from 'underscore';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/product-settings.hbs';

    var MAX_NAME_LENGTH = 100;
    var MAX_DESCRIPTION_LENGTH = 300;

    var alertChannel = Radio.channel('alerts');
    var view = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        ui: {
            name: '#product-settings-modal-name',
            description: '#product-settings-modal-description',
            submitButton: 'button.submit',
            name_help_block: '.name-counter',
            description_help_block: '.description-counter',
            form: 'form'
        },
        onRender: function(){
            this.check_validation(
                this.ui.name,
                MAX_NAME_LENGTH,
                this.ui.name_help_block,
                this.ui.submitButton);
            this.check_validation(
                this.ui.description,
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_help_block,
                this.ui.submitButton);
                this.ui.submitButton.prop('disabled', false);
        },
        events: {
            'submit form': 'onSubmit',
            'change @ui.name': 'validateName',
            'keyup @ui.name': 'validateName',
            'paste @ui.name': 'validateName',
            'mouseup @ui.name': 'validateName',
            'change @ui.description': 'validateDescription',
            'keyup @ui.description': 'validateDescription',
            'paste @ui.description': 'validateDescription',
            'mouseup @ui.description': 'validateDescription'
        },
        validateName: function (e) {
            this.check_validation(
                $(e.target),
                MAX_NAME_LENGTH,
                this.ui.name_help_block,
                this.ui.submitButton);
        },
        validateDescription: function (e) {
            this.check_validation(
                $(e.target),
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_help_block);
            if (this.ui.name.value) {
                this.ui.submitButton.prop('disabled', false);
            }
        },
        initialize: function () {
            this.destroyOnClose();
            this.focusFirstInput();
        },

        onSubmit: function (e) {
            var form_data = {};
            var self = this;

            e.preventDefault();

            // get form values
            this.ui.form.serializeArray().forEach(function (obj) {
                form_data[obj.name] = obj.value;
            });

            // Remove whitespace
            form_data.name = form_data.name.trim();
            form_data.description = form_data.description.trim();

            var options = {
                success: function (model, response) {
                    var message = 'Your product settings were updated';
                    alertChannel.request('showAlert', { message: message, messageType: 'success' });
                    // Close the modal
                    self.closeDialog();
                },
                error: function (model, resp, options) {
                    var msg;
                    var err = resp.responseJSON.errors[0] || undefined;
                    var ui_element = _.flatten(err.detail.split(" ", 1));

                    try {
                        msg = err.detail;
                    } catch (e) {
                        console.error(e);
                        msg = "no message text";
                        return;
                    }

                    self.showAlert('danger', msg);

                    if (self.ui[ui_element]) {
                        self.ui[ui_element].addClass("has-error");
                    }
                },
                patch: true,
                wait: true
            };
            var attrs = {};
            if ('name' in form_data) {
                attrs.name = form_data.name;
            }
            if ('description' in form_data) {
                attrs.description = form_data.description;
            }
            this.model.save({
                data: {
                    type: 'product',
                    id: this.model.id,
                    attributes: attrs
                }
            }, options);
        }
    });
    export default view;

